var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.templateArgs.lectors),function(lector){return _c('div',[_c('p',[_vm._v(_vm._s(lector.fullName))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }